export default {
  webUrl: 'http://jjb-h5.oxygen-cc.com/#/',
  // articeUrl: 'https://xiulem-h5.ydd100.cn',
  // articeUrls: 'https://xiulem-api.ydd100.cn/xlm/api/gzh/article/redirect?redirectUrl=',
  // // articeUrls: 'xiulem-api.ydd100.cn/xlm',
  // placeholder: '../assets/1@3x.png',
  // authUrl: 'https://xiulem-api.ydd100.cn/xlm/gzh/auth?type='
  // authUrl: 'http://api.ldnz.ydd100.cn:8502/xlm/gzh/auth?type='
}



// WEBPACK FOOTER //
// ./src/utils/config.js